<template>
  <div>
    <form
      :action="url"
      ref="form"
      method="post"
      novalidate="novalidate"
      target="_blank"
      class="height-0"
    >
      <input
        type="hidden"
        name="__VIEWSTATEGENERATOR"
        id="__VIEWSTATEGENERATOR"
        :value="account.event ? account.event.__VIEWSTATEGENERATOR : ''"
      />
      <input
        type="hidden"
        name="__EVENTTARGET"
        id="__EVENTTARGET"
        :value="account.event ? account.event.__EVENTTARGET : ''"
      />

      <input
        type="hidden"
        name="__EVENTARGUMENT"
        id="__EVENTARGUMENT"
        value=""
      />

      <input
        type="hidden"
        name="__VIEWSTATE"
        id="__VIEWSTATE"
        :value="account.event ? account.event.__VIEWSTATE : ''"
      />

      <input
        type="hidden"
        name="__EVENTVALIDATION"
        id="__EVENTVALIDATION"
        :value="account.event ? account.event.__EVENTVALIDATION : ''"
      />

      <input type="text" name="lstLang" value="Default8.aspx?lang=EN-GB" />
      <input
        name="txtUserName"
        type="text"
        id="txtUserName"
        maxlength="16"
        :value="account.username"
      />
      <input
        name="password"
        type="text"
        id="txtPassword"
        maxlength="16"
        :value="account.password"
      />
    </form>
    <button class="button full-100 is-primary" @click="handlePlayOnWeb">
      {{ $t('playGameBtn') }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'LoginSlotUfabet',
  props: {
    account: {
      type: Object
    },
    trigger: {
      type: Number
    }
  },
  watch: {
    trigger: {
      // immediate: true,
      async handler() {
        this.handlePlayOnWeb()
      }
    }
  },
  data() {
    return {
      url: process.env.VUE_APP_CUSTOM_UFA
        ? `${process.env.VUE_APP_CUSTOM_UFA}/HomeSmart.aspx?lang=EN-GB`
        : process.env.VUE_APP_LAOS === 'true'
        ? 'https://www.betufa.com/HomeSmart.aspx?lang=EN-GB'
        : 'https://www.ufabet.com/HomeSmart.aspx?lang=EN-GB'
    }
  },
  methods: {
    handlePlayOnWeb() {
      this.$refs.form.submit()
    }
  }
}
</script>

<style scoped lang="scss">
.height-0 {
  height: 0px !important;
  visibility: hidden;
}
</style>
